import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Badge } from 'antd'; // Assuming you're using Ant Design's Badge component
import NotificationDrawer from '@components/UserSpace/components/Notifications/NotificationDrawer'; // Assume this is a separate component
import { fetchNotifications } from '../../features/notifications/notificationSlice';

const NotificationManager = ({ children }) => {
  const { notifications } = useSelector((state) => state.notification);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [hasViewedNotifications, setHasViewedNotifications] = useState(false);
  const { userOrganizationId } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  // Check if there are unread notifications
  const hasUnreadNotifications =
    notifications?.some((notification) => !notification.is_read) && !hasViewedNotifications;

  // Toggle drawer visibility and mark notifications as viewed when opened
  const toggleDrawer = () => {
    setDrawerVisible((prev) => !prev);
    if (!drawerVisible) {
      setHasViewedNotifications(true);
    }
  };

  // Reset hasViewedNotifications when new unread notifications arrive
  useEffect(() => {
    if (notifications?.some((notification) => !notification.is_read)) {
      setHasViewedNotifications(false);
    }
  }, [notifications]);

  const fetchNotification = useCallback(async () => {
    dispatch(fetchNotifications({ skip: 0, limit: 5 }));
  }, [dispatch]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      fetchNotification();
    }, 500000);
    fetchNotification();
    return () => clearInterval(intervalId);
  }, [userOrganizationId]);

  // Clone the children and add onClick handler
  const childrenWithClickHandler = React.cloneElement(children, {
    onClick: toggleDrawer,
  });

  return (
    <>
      <NotificationDrawer visible={drawerVisible} onClose={() => setDrawerVisible(false)} />
      <Badge dot={hasUnreadNotifications} offset={[-5, 5]}>
        {childrenWithClickHandler}
      </Badge>
    </>
  );
};

export default NotificationManager;
